import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <div className="relative rounded-3xl overflow-hidden mb-10 md:mb-14 mx-auto max-w-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20warm-toned%20illustration%20of%20diverse%20people%20reading%20comics%20on%20tablets%20and%20phones%20in%20a%20cozy%20communal%20space%2C%20soft%20golden%20ambient%20lighting%2C%20comfortable%20modern%20interior%20with%20plants%20and%20warm%20textures%2C%20grain%20texture%20overlay%2C%20editorial%20lifestyle%20composition%2C%20warm%20amber%20and%20cream%20tones%2C%20inclusive%20diverse%20scene%2C%20peaceful%20reading%20atmosphere%2C%20high%20quality%20digital%20art&width=1400&height=700&seq=cta-visual-01&orientation=landscape"
            alt="加入韩漫社区"
            className="w-full aspect-[2/1] object-cover"
            loading="lazy"
          />
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight mb-4">
          准备好开始你的
          <span className="font-serif italic font-semibold text-primary-500"> 韩漫之旅 </span>
          了吗？
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto leading-relaxed mb-10">
          数千部热门韩国漫画等你来探索，完全免费，下拉式流畅阅读，随时随地畅享精彩故事。
        </p>

        <Link
          to="/category/all"
          className="inline-block px-10 py-4 bg-foreground-950 text-background-50 font-medium rounded-full text-sm md:text-base hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          免费开始阅读
        </Link>
      </div>
    </section>
  );
}